<template>
  <div class="evaluation-viewer-answer-item">
    {{ result }} / {{ answer }}
  </div>
</template>

<script>
/**
   * 'EvaluationViewerAnswerItem' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018re
   */
export default {
  name: 'EvaluationViewerAnswerItem',
  props: {
    type: {
      type: String,
      required: true
    },
    answers: {
      type: Array,
      required: true
    },
    result: {
      type: [String, Array, Boolean],
      default: null
    }
  },
  computed: {
    answer () {
      switch (typeof this.result) {
        case 'boolean':
          return this.result ? 'Si' : 'No'
        case 'string':
          let r = this.answers.find(x => {
            return x.$id === this.result
          })
          return r ? r.name : 'No encontrado'
        default:
          return 'Sin respuesta'
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-answer-item {

    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-answer-item.vue